<template lang='pug'>
v-text-field(
  :value="value"
  :append-icon='showPassword ? "mdi-eye" : "mdi-eye-off"',
  name='password'
  :type='showPassword ? "text" : "password"',
  @change="$emit('input', $event)"
  @click:append='showPassword = !showPassword'
  v-bind="$attrs"
  v-on="$listeners"
)
</template>

<script>
export default {
  props:{
    value:{ type:String, required:false, default:'' },
  },
  data() {
    return { showPassword:false };
  },

};
</script>

<style>

</style>
